import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import { ForgotPassword } from 'components';
import PasswordTimer from 'components/common/PasswordTimer';
import React from 'react';
import { useMedia } from 'react-use';
import { POST, login } from 'utils';
import { api } from 'utils/apiRoutes';
import { setCookie } from 'utils/common_function';

const { Item } = Form;
const { Password } = Input;

const Login = () => {
  const [tab, setTab] = React.useState<string>('1');

  const [loading, setLoading] = React.useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const mobileScreen = useMedia('(max-width:768px)');
  const handleLogin = async (data: login) => {
    try {
      const res = await POST(api.login, data);
      setLoading(true);
      if (res.status === 200) {
        setCookie('access_token', res.data?.access);
        localStorage.setItem('refresh', res.data?.refresh);
        setLoading(false);
        window.location.reload();
      }
    } catch (e) {
      console.warn(e);
      messageApi.error(
        'The email or password you entered is incorrect. Please try again',
      );
    }
  };

  const changeTab = (tab: string) => {
    setTab(tab);
  };

  return (
    <div
      style={{
        background: mobileScreen
          ? `url('/mobile/bg_mobile.svg') no-repeat `
          : `url('/assets/Background.png') no-repeat `,
        // height: mobileScreen ? '90vh' : '120vh',
        backgroundSize: 'cover',
        paddingBottom: mobileScreen ? '20px' : '200px',
        width: '100%',
      }}
      className={'login_page'}
    >
      {contextHolder}
      <div>
        <img
          src={'/assets/brand.png'}
          alt={'logo'}
          style={{ margin: '0 0 2.5rem 6rem' }}
          className="company-logo"
        />

        <section className={'login_content'}>
          <section className={'login_content_form'}>
            <span
              className={'top_left'}
              style={{
                background: `url('/assets/left.svg') no-repeat`,
              }}
            >
              {tab === '2' && (
                <Button
                  icon={<ArrowLeftOutlined color={'#000'} />}
                  type={'text'}
                  onClick={() => setTab('1')}
                  style={{ position: 'absolute', left: '37px', top: '38px' }}
                  size={'large'}
                />
              )}
            </span>
            {tab !== '4' && (
              <h1
                style={{
                  marginTop: '6rem',
                  fontSize: '36px',
                  fontWeight: 700,
                  marginLeft: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#000',
                }}
              >
                {tab === '1'
                  ? 'Sign In'
                  : tab === '2'
                  ? 'Forgot your password?'
                  : 'Set new password'}
              </h1>
            )}
            {tab === '3' && (
              <p
                className="has-text-centered"
                style={{ color: '#000', fontSize: ' 0.875rem' }}
              >
                A verification code has been sent to your email.
                <br />
                Allow to input maximum 6 numbers.
              </p>
            )}
            <div>
              {
                {
                  '1': (
                    <Form
                      className={'login_content_form_main'}
                      name={'login'}
                      onFinish={handleLogin}
                    >
                      <Item
                        name={'username'}
                        rules={[
                          { required: true, message: 'Email is required' },
                          { type: 'email', message: 'Invalid Email ' },
                        ]}
                      >
                        <Input
                          id="username"
                          placeholder={'Email'}
                          prefix={<img src={'/assets/user.svg'} alt={'icon'} />}
                          size={'large'}
                          style={{ background: '#EFEEF4' }}
                          type={'email'}
                        />
                      </Item>
                      <Item
                        rules={[
                          {
                            required: true,
                            message: 'Password is required',
                          },
                          {
                            max: 20,
                            message:
                              'Password can not longer than 20 character',
                          },
                        ]}
                        name={'password'}
                      >
                        <Password
                          id="password"
                          placeholder={'Password'}
                          prefix={<img src={'/assets/lock.svg'} alt={'icon'} />}
                          size={'large'}
                          style={{ background: '#EFEEF4' }}
                        />
                      </Item>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div style={{ width: '2em' }} />
                        <Item>
                          <span
                            onClick={() => {
                              setTab('2');
                            }}
                            className={'forgot_pass_btn is-clickable'}
                          >
                            Forgot password ?
                          </span>
                        </Item>
                      </div>
                      <Item>
                        <button
                          type={'submit'}
                          className={'login_btn'}
                          disabled={loading}
                        >
                          Sign In
                        </button>
                      </Item>
                    </Form>
                  ),
                  '2': <ForgotPassword changeTab={changeTab} />,
                  '3': <PasswordTimer changeTab={changeTab} />,
                  '4': (
                    <>
                      <div className="is-flex is-justify-content-center ">
                        <img
                          alt="icon"
                          src="/icons/success_pass.png"
                          width={380}
                          height={320}
                        />
                      </div>
                      <div className="has-text-centered">
                        <h1
                          style={{
                            fontSize: 24,
                            color: '#000',
                            fontWeight: 600,
                          }}
                        >
                          Password changed successfully
                        </h1>
                        <p style={{ color: '#000', fontSize: '0.875rem' }}>
                          You can sign in right now
                        </p>
                        <span
                          onClick={() => setTab('1')}
                          className="sign-in-btn is-clickable"
                          style={{ fontSize: '0.875rem' }}
                        >
                          Sign In Now
                        </span>
                      </div>
                    </>
                  ),
                }[tab]
              }
            </div>
            <span className={'right_center'}>
              <img src={'/assets/right.svg'} alt={'icon'} />
            </span>
            <span
              className={'bottom_left'}
              style={{ background: `url('/assets/bottom.svg') no-repeat` }}
            ></span>
          </section>
        </section>
      </div>
    </div>
  );
};

export default Login;
